export const REQUEST_INVITATION_LIST = "REQUEST_INVITATION_LIST"
export const REQUEST_INVITATION = "REQUEST_INVITATION"
export const REQUEST_KIOSK_INFO = "REQUEST_KIOSK_INFO"